import { ClickAwayListener } from "@mui/base/ClickAwayListener";
import { Input as InputMui } from "@mui/material";
import { ReactComponent as CheckIcon } from "components/Icons/check.svg";
import { ReactComponent as XCloseIcon } from "components/Icons/x-close.svg";
import { Tooltip } from "components/Tooltips/Tooltip";
import { useMessage } from "hooks/intl";
import { useState } from "react";
import { useStyles } from "./InlineInput";

interface Props {
  onEditModeClose?: (value?: string) => void;
  setFieldValue: (value: string) => void;
  initialValue?: string;
  setIsEditing: (val: boolean) => void;
  maxLength: number;
  isError: boolean;
  setFieldError: () => void;
  autoFocus?: boolean;
  dataTestId: string;
  type?: "number" | "text";
}

export const Input = ({
  onEditModeClose,
  initialValue,
  setFieldValue,
  setIsEditing,
  maxLength,
  isError,
  setFieldError,
  autoFocus,
  dataTestId,
  type = "text",
}: Props) => {
  const [value, setValue] = useState(initialValue ?? "");
  const classes = useStyles({});
  const { message } = useMessage();

  const isValueToLong = maxLength && value.length >= maxLength;

  const tooltip = isError
    ? isError.toString()
    : isValueToLong
      ? message(
          { id: "maxNumberOfChars" },
          {
            maxNumber: maxLength,
          },
        )
      : "";

  return (
    <ClickAwayListener
      onClickAway={() => {
        if (isValueToLong) return;
      }}
    >
      <div>
        <Tooltip text={tooltip}>
          <div
            className={`${classes.content} ${isValueToLong || isError ? classes.contentToLong : ""}`}
          >
            <InputMui
              type={type}
              disableUnderline
              onChange={(e) => {
                setValue(e.target.value);
              }}
              value={value}
              className={classes.input}
              multiline={type === "text"}
              autoFocus={autoFocus}
              inputProps={{
                "data-test-id": `${dataTestId}-field`,
              }}
            />
            <div
              className={`${classes.actionIconsWrapper} ${isValueToLong ? classes.contentToLong : ""}`}
              onClick={(e) => {
                if (isValueToLong) return;
                onEditModeClose?.(value);
                setFieldValue(value);
                setIsEditing(false);
                setFieldError();
              }}
            >
              <CheckIcon
                className={classes.icon}
                data-test-id={`${dataTestId}-checkmark`}
              />
            </div>
            <div
              className={`${classes.actionIconsWrapper} ${isValueToLong ? classes.contentToLong : ""}`}
              onClick={() => {
                setIsEditing(false);
              }}
            >
              <XCloseIcon
                className={classes.icon}
                data-test-id={`${dataTestId}-close`}
              />
            </div>
          </div>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};
